<template>
  <div
    class="product"
    :style="{
      background: coloredbg
        ? `url(${globalData.plan.product.bg}) no-repeat center/cover`
        : '',
    }"
  >
    <block-title
      v-if="!noTitle"
      :en="globalData.index.product.enTitle"
      :title="globalData.index.product.chTitle"
      :sub="globalData.index.product.chBrief"
    ></block-title>
    <div
      class="prod-display content-limit"
      :style="{ 'padding-top': noTitle ? '0' : '' }"
    >
      <div class="prod-tabs">
        <div
          class="prod-item"
          :class="{ 'prod-active': tabIndex === index }"
          @click="switchTabs(index)"
          v-for="(item, index) of globalData.index.product.display.tabs"
          :key="index"
        >
          <!-- <img
                class="prod-icon"
                :src="tabIndex === index ? item.activeIcon : item.icon"
                alt=""
              /> -->
          <svg
            v-if="index === 0"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            fill="none"
            version="1.1"
            width="40"
            height="40"
            viewBox="0 0 40 40"
          >
            <g>
              <g>
                <path
                  d="M13.716445922851562,20.302366474609375C13.716445922851562,23.605716474609373,16.394335922851564,26.283636474609374,19.697675922851563,26.283636474609374C23.00102592285156,26.283636474609374,25.67894592285156,23.605716474609373,25.67894592285156,20.302366474609375C25.67894592285156,16.999026474609376,23.00102592285156,14.321136474609375,19.697675922851563,14.321136474609375C16.394335922851564,14.321136474609375,13.716445922851562,16.999026474609376,13.716445922851562,20.302366474609375C13.716445922851562,20.302366474609375,13.716445922851562,20.302366474609375,13.716445922851562,20.302366474609375Z"
                  fill="currentColor"
                  fill-opacity="1"
                />
              </g>
              <g>
                <path
                  d="M19.701282666015626,4.511878967285156C10.982132666015625,4.511878967285156,3.913482666015625,11.579638967285156,3.913482666015625,20.298778967285156C3.913482666015625,29.017878967285156,10.982092666015625,36.08647896728516,19.701282666015626,36.08647896728516C28.420382666015627,36.08647896728516,35.48808266601563,29.017878967285156,35.48808266601563,20.298778967285156C35.48808266601563,11.579608967285157,28.420382666015627,4.511878967285156,19.701282666015626,4.511878967285156C19.701282666015626,4.511878967285156,19.701282666015626,4.511878967285156,19.701282666015626,4.511878967285156ZM19.701282666015626,7.070808967285156C27.006982666015624,7.070808967285156,32.92918266601562,12.993018967285156,32.92918266601562,20.298778967285156C32.92918266601562,27.604478967285157,27.006982666015624,33.52757896728515,19.701282666015626,33.52757896728515C12.395502666015625,33.52757896728515,6.472412666015625,27.604478967285157,6.472412666015625,20.298778967285156C6.472412666015625,12.993018967285156,12.395502666015625,7.070808967285156,19.701282666015626,7.070808967285156C19.701282666015626,7.070808967285156,19.701282666015626,7.070808967285156,19.701282666015626,7.070808967285156Z"
                  fill="currentColor"
                  fill-opacity="1"
                />
              </g>
              <g>
                <path
                  d="M20.301467202148437,0C21.000637202148436,0,21.567427202148437,0.571552,21.567427202148437,1.2766C21.567427202148437,1.2766,21.567427202148437,5.22298,21.567427202148437,5.22298C21.567427202148437,5.92803,21.000637202148436,6.49958,20.301467202148437,6.49958C19.602310202148438,6.49958,19.035507202148438,5.92803,19.035507202148438,5.22298C19.035507202148438,5.22298,19.035507202148438,1.2766,19.035507202148438,1.2766C19.035507202148438,0.571551,19.602310202148438,0,20.301467202148437,0C20.301467202148437,0,20.301467202148437,0,20.301467202148437,0ZM20.301467202148437,33.5005C21.000637202148436,33.5005,21.567427202148437,34.072,21.567427202148437,34.777C21.567427202148437,34.777,21.567427202148437,38.7234,21.567427202148437,38.7234C21.567427202148437,39.4284,21.000637202148436,40,20.301467202148437,40C19.602310202148438,40,19.035507202148438,39.4284,19.035507202148438,38.7234C19.035507202148438,38.7234,19.035507202148438,34.777,19.035507202148438,34.777C19.035507202148438,34.072,19.602310202148438,33.5004,20.301467202148437,33.5004C20.301467202148437,33.5004,20.301467202148437,33.5005,20.301467202148437,33.5005Z"
                  fill="currentColor"
                  fill-opacity="1"
                />
              </g>
              <g>
                <path
                  d="M0,20.301467202148437C0,19.602310202148438,0.571552,19.035507202148438,1.2766,19.035507202148438C1.2766,19.035507202148438,5.22298,19.035507202148438,5.22298,19.035507202148438C5.92803,19.035507202148438,6.49958,19.602310202148438,6.49958,20.301467202148437C6.49958,21.000637202148436,5.92803,21.567427202148437,5.22298,21.567427202148437C5.22298,21.567427202148437,1.2766,21.567427202148437,1.2766,21.567427202148437C0.571551,21.567427202148437,0,21.000637202148436,0,20.301467202148437C0,20.301467202148437,0,20.301467202148437,0,20.301467202148437ZM33.5005,20.301467202148437C33.5005,19.602310202148438,34.072,19.035507202148438,34.777,19.035507202148438C34.777,19.035507202148438,38.7234,19.035507202148438,38.7234,19.035507202148438C39.4284,19.035507202148438,40,19.602310202148438,40,20.301467202148437C40,21.000637202148436,39.4284,21.567427202148437,38.7234,21.567427202148437C38.7234,21.567427202148437,34.777,21.567427202148437,34.777,21.567427202148437C34.072,21.567427202148437,33.5004,21.000637202148436,33.5004,20.301467202148437C33.5004,20.301467202148437,33.5005,20.301467202148437,33.5005,20.301467202148437Z"
                  fill="currentColor"
                  fill-opacity="1"
                />
              </g>
            </g>
          </svg>

          <svg
            v-if="index === 1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            fill="none"
            version="1.1"
            width="40"
            height="40"
            viewBox="0 0 40 40"
          >
            <defs>
              <clipPath id="master_svg0_96_9845">
                <rect x="0" y="0" width="40" height="40" rx="0" />
              </clipPath>
            </defs>
            <g clip-path="url(#master_svg0_96_9845)">
              <g>
                <path
                  d="M24.0052,9L8.99476,9C7.37025,9,5.8966899999999995,9.567414,4.81731,10.48899C3.696077,11.44596,3,12.7841,3,14.26565L3,25.7344C3,27.2156,3.696077,28.554,4.81731,29.511C5.8966899999999995,30.4329,7.37025,31,8.99476,31L24.0052,31C27.3156,31,30,28.6428,30,25.7344L30,14.26565C30,11.3575,27.3156,9,24.0052,9ZM27.3792,25.7344C27.3792,27.277,25.8657,28.5317,24.0052,28.5317L8.99476,28.5317C7.13427,28.5317,5.62083,27.277,5.62083,25.7344L5.62083,14.26565C5.62083,12.72326,7.13427,11.468309999999999,8.99476,11.468309999999999L24.0052,11.468309999999999C25.8657,11.468309999999999,27.3792,12.72326,27.3792,14.26565L27.3792,25.7344Z"
                  fill="currentColor"
                  fill-opacity="1"
                />
              </g>
              <g>
                <path
                  d="M15.60765,17.42819L19.82225,20.000149999999998L15.60765,22.5721L15.60765,17.42819ZM14.99025,14.55704C13.9584,14.55704,13,15.30279,13,16.36534L13,23.634700000000002C13,24.6969,13.9584,25.442999999999998,14.99025,25.442999999999998C15.36108,25.442999999999998,15.74142,25.346600000000002,16.08996,25.1339L22.045949999999998,21.499409999999997C23.2178,20.78438,23.2178,19.21621,22.045949999999998,18.50089L16.08996,14.86638C15.74142,14.653690000000001,15.36108,14.55734,14.99025,14.55734L14.99025,14.55704ZM35.0098,12C34.6389,12.000298302,34.2586,12.0966497,33.91,12.30904L30.2853,14.52095L27.678,16.112090000000002L27.678,18.96862L30.2853,17.37748L34.392399999999995,14.87115L34.392399999999995,25.1291L30.2853,22.622799999999998L27.678,21.03168L27.678,23.888199999999998L30.2853,25.479100000000003L33.91,27.691000000000003C34.2589,27.9036,34.6389,28,35.0098,28C36.0413,28,37,27.2539,37,26.1917L37,13.8083C37,12.746052,36.0413,12,35.0098,12Z"
                  fill="currentColor"
                  fill-opacity="1"
                />
              </g>
            </g>
          </svg>

          <svg
            v-if="index === 2"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            fill="none"
            version="1.1"
            width="40"
            height="40"
            viewBox="0 0 40 40"
          >
            <defs>
              <clipPath id="master_svg0_96_9969">
                <rect x="0" y="0" width="40" height="40" rx="0" />
              </clipPath>
            </defs>
            <g clip-path="url(#master_svg0_96_9969)">
              <g>
                <path
                  d="M17.07936,8.9528C17.07936,10.583590000000001,18.32975,11.90561,19.87219,11.90561C21.41462,11.90561,22.66502,10.583590000000001,22.66501,8.9528C22.66502,7.32201,21.41462,6,19.87219,6C18.32975,6,17.07936,7.32201,17.07936,8.9528ZM21.747419999999998,13.212589999999999L18.11332,13.212589999999999C16.88668,13.212589999999999,15.784053,13.68455,15,14.43889L15,22.0549L17.73178,22.0549L18.31934,31L21.65967,31L22.22816,22.0549L25,22.0549L25,14.58209C24.21022,13.745059999999999,23.048450000000003,13.212589999999999,21.747419999999998,13.212589999999999Z"
                  fill="currentColor"
                  fill-opacity="1"
                />
              </g>
              <g>
                <path
                  d="M24.5288,25.00628631L24.5288,26.62436C27.836,27.12739,30.108,28.17117,30.108,29.37634C30.108,31.08035,25.5823,32.45738,20.000999999999998,32.45738C14.41977,32.45738,9.892,31.08035,9.892,29.37634C9.892,28.16698,12.180340000000001,27.1211,15.50993,26.61598L15.50993,25C9.98166,25.616207,6.00000202103,27.341169999999998,6.00000202103,29.37634C5.99592669,31.9292,12.26796,34,19.999000000000002,34C27.73,34,34,31.9292,34,29.37843C34,27.347459999999998,30.0367,25.628782,24.5288,25.00628631Z"
                  fill="currentColor"
                  fill-opacity="1"
                />
              </g>
            </g>
          </svg>

          <svg
            v-if="index === 3"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            fill="none"
            version="1.1"
            width="40"
            height="40"
            viewBox="0 0 40 40"
          >
            <defs>
              <clipPath id="master_svg0_96_9899">
                <rect x="0" y="0" width="40" height="40" rx="0" />
              </clipPath>
            </defs>
            <g clip-path="url(#master_svg0_96_9899)">
              <g>
                <path
                  d="M20.0027,6C12.26878,6,6,12.26878,6,20C6,27.7312,12.26878,34,20,34C27.7312,34,34,27.7312,34,20C34.002700000000004,12.26878,27.734,6,20.0027,6ZM20.0027,13C19.0798,13,18.1815,12.91784,17.3079,12.764479999999999C18.1268,9.47535,19.3592,7.74726,20.0027,7.74726C20.6463,7.74726,21.878700000000002,9.47535,22.6976,12.764479999999999C21.823900000000002,12.915099999999999,20.9229,13,20.0027,13ZM24.3983,12.361889999999999C23.9738,10.62011,23.4041,9.15493,22.7387,8.06768C24.7269,8.52504,26.529,9.4644,28.0215,10.75978C26.9178,11.438970000000001,25.6991,11.98122,24.3983,12.361889999999999ZM15.60446,12.361889999999999C14.3036,11.98122,13.08764,11.43623,11.986699999999999,10.75978C13.47653,9.46714,15.27856,8.52778,17.2641,8.07316C16.598599999999998,9.15493,16.0317,10.62011,15.60446,12.361889999999999ZM25.2363,19.1236C25.1952,17.3271,25.0282,15.62637,24.7543,14.07903C26.3948,13.61072,27.9202,12.91236,29.2786,12.022300000000001C30.9464,13.961269999999999,32.0145,16.4206,32.206199999999995,19.1236L25.2363,19.1236ZM7.79382,19.1236C7.98826,16.423299999999998,9.05086,13.96401,10.715959999999999,12.02504C12.07434,12.915099999999999,13.6025,13.60524,15.24844,14.07629C14.97731,15.62637,14.80751,17.3271,14.76643,19.1236L7.79382,19.1236ZM16.5164,19.1236C16.557499999999997,17.3818,16.7164,15.82903,16.951900000000002,14.47613C17.9405,14.65141,18.9566,14.74726,20.0027,14.74726C21.0462,14.74726,22.0649,14.65415,23.0536,14.47887C23.2891,15.83177,23.4452,17.3846,23.489,19.1236L16.5164,19.1236ZM29.2813,27.975C27.9229,27.0849,26.3975,26.3865,24.757,25.9182C25.0282,24.3682,25.198,22.6674,25.239,20.8736L32.2117,20.8736C32.0145,23.5794,30.9491,26.0387,29.2813,27.975ZM16.951900000000002,25.5211C16.7164,24.1682,16.560299999999998,22.6154,16.5164,20.8736L23.4836,20.8736C23.4425,22.6099,23.2864,24.1655,23.0481,25.5184C22.0649,25.3431,21.0462,25.25,20,25.25C18.9566,25.25,17.9378,25.3486,16.951900000000002,25.5211ZM10.7187,27.9722C9.0536,26.036,7.98826,23.5767,7.7965599999999995,20.8764L14.76917,20.8764C14.81025,22.6729,14.97731,24.3736,15.25117,25.9237C13.607980000000001,26.392,12.07981,27.0822,10.7187,27.9722ZM20.0027,32.25C19.3592,32.25,18.1268,30.5219,17.3079,27.2328C18.178800000000003,27.0822,19.0798,26.9973,20.0027,26.9973C20.9257,26.9973,21.823900000000002,27.0822,22.6976,27.2328C21.875999999999998,30.5219,20.6463,32.25,20.0027,32.25ZM22.7387,31.9323C23.4041,30.8451,23.9738,29.3799,24.3983,27.6381C25.7019,28.0188,26.9178,28.561,28.0215,29.2375C26.529,30.5356,24.7269,31.475,22.7387,31.9323ZM17.2641,31.9323C15.27582,31.475,13.47653,30.5383,11.986699999999999,29.2457C13.08764,28.5638,14.3036,28.0243,15.60446,27.6436C16.0317,29.3799,16.598599999999998,30.8451,17.2641,31.9323Z"
                  fill="currentColor"
                  fill-opacity="1"
                />
              </g>
            </g>
          </svg>
          <div class="prod-txt">
            {{ item.txt }}
          </div>
        </div>
      </div>
      <div
        class="prod-list"
        v-for="(outerItem, outerIndex) of globalData.index.product.display.list"
        v-if="tabIndex === outerIndex"
        :key="outerIndex"
      >
        <div
          class="prod-item"
          v-for="(item, index) of displayList(outerItem)"
          :key="index"
          @click="showDetail(item)"
        >
          <div class="prod-inner">
            <img class="prod-img" :src="item.img" alt="" />
            <div class="prod-hover">
              <div class="prod-innerTxt">
                {{ item.name }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="prod-button" v-if="limited" @click="navMore">
        查看更多
        <img src="@/asset/index/ic_index_50.png" class="icon" alt="" />
      </div>
    </div>

    <div class="hover-pop-success" v-if="showing">
      <div class="private-back" @click="closeDetail"></div>
      <div
        class="private-content"
        :style="{
          background: `url(${globalData.productCenter.prompt_bg}) no-repeat center/cover`,
        }"
      >
        <div class="private-title">
          产品详情
          <img
            @click="closeDetail"
            class="private-close success-close"
            src="/static-images/getplan/ic_close.png"
          />
        </div>
        <div class="pd-name">{{ showingDetail.name }}</div>
        <div class="pd-content">
          <div class="pd-left">
            <img :src="showingDetail.img" class="pd-img" alt="" />
          </div>
          <div class="pd-right">
            <div class="pd-brief">{{ showingDetail.brief }}</div>
            <div class="pd-feature" v-html="showingDetail.feature"></div>
          </div>
        </div>
        <div class="pd-buttons">
          <div class="pd-button" @click="getPlan">解决方案</div>
          <div class="private-button" @click="chat">立即咨询</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  props: {
    limited: {
      type: Boolean,
      default: true,
    },
    coloredbg: {
      type: Boolean,
      default: false,
    },
    noTitle: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: null,
    },
  },
  methods: {
    getPlan() {
      this.$router.push("/getPlan");
    },
    chat() {
      this.$chat();
    },
    closeDetail() {
      this.showing = false;
      document.body.style.overflow = "auto";
    },
    showDetail(item) {
      this.showingDetail = item;
      this.showing = true;
      document.body.style.overflow = "hidden";
    },
    navMore() {
      this.$router.push("/productCenter");
    },
    switchTabs(index) {
      this.tabIndex = index;
    },
    displayList(list) {
      return this.limited ? list.slice(0, 12) : list;
    },
  },
  data() {
    return {
      realTabIndex: 0,
      showing: false,
      showingDetail: {},
    };
  },
  computed: {
    ...mapGetters(["globalData"]),
    tabIndex: {
      get() {
        if (this.index !== null) {
          return this.index;
        } else {
          return this.realTabIndex;
        }
      },
      set(i) {
        if (this.index !== null) {
          this.$emit("update:index", i);
        } else {
          this.realTabIndex = i;
        }
      },
    },
  },
};
</script>
<style scoped lang="scss">
.prod-display {
  padding: 80px 140px 0;

  .prod-tabs {
    display: flex;
    align-items: flex-end;
    justify-content: center;

    .prod-item {
      width: 25%;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      font-size: 24px;
      color: #666666;
      cursor: pointer;

      .prod-icon {
        height: 32px;
        margin-right: 16px;
      }

      .prod-txt {
        padding: 0 5px;
        box-sizing: border-box;
      }

      &:hover {
        color: #096dd9;
      }
    }

    .prod-active {
      color: #096dd9;
      flex-wrap: wrap;

      .prod-icon {
        height: 80px;
        margin-right: 0;
      }

      .prod-txt {
        width: 100%;
        margin-top: 16px;
      }
    }
  }

  .prod-list {
    display: grid;
    grid-template-columns: repeat(3, 1fr);   
    // align-items: center;
    // justify-content: center;
    // flex-wrap: wrap;
    // justify-content: space-between;
    margin-top: 80px;
    gap: 25px;

    .prod-item {
      // width: calc(33% - 25px);
      box-sizing: border-box;
      padding: 20px;
      background-color: white;
      cursor: pointer;
      box-shadow: 5px 8px 20px 0px #dadada;
      border-radius: 8px;

      .prod-inner {
        position: relative;

        .prod-img {
          width: 100%;
          height: 440px;
          object-fit: cover;
        }

        .prod-hover {
          position: absolute;
          border-radius: 8px;
          width: calc(100% - 32px);
          height: 20px;
          left: 16px;
          bottom: 16px;
          font-size: 20px;
          color: white;
          display: flex;
          align-items: center;
          justify-content: center;
          line-height: 1.5;
          transition: all 0.2s;
          font-size: 18px;
          color: #666666;

          .prod-innerTxt {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
          }
        }

        &:hover {
          .prod-hover {
            opacity: 0.8;
            height: 40%;
            background: linear-gradient(180deg, #4e99fd 0%, #5482fa 100%);
            color: white;
            font-size: 20px;

            .prod-innerTxt {
              white-space: normal;
            }
          }
        }
      }
    }
  }
}
.product {
  padding: 100px 0 80px;
}
.prod-button {
  font-size: 24px;
  color: #fffdfd;
  background: linear-gradient(180deg, #4e99fd 0%, #5482fa 100%);
  border-radius: 2px 2px 2px 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
  margin: 0 auto;
  margin-top: 40px;
  width: 217px;
  cursor: pointer;
  gap: 12px;
  .icon {
    width: 30px;
  }
}

.privateBox,
.hover-pop-success {
  .private-back {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba($color: #000000, $alpha: 0.6);
    z-index: 999;
  }
  .private-content {
    position: fixed;
    width: 1280px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
    .private-title {
      color: white;
      font-size: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 60px;
      background: linear-gradient(180deg, #4e99fd 0%, #5482fa 100%);
      position: relative;
      .private-close {
        position: absolute;
        right: 24px;
        top: 22px;
        width: 16px;
        cursor: pointer;
      }
    }
    .private-button {
      width: 157px;
      height: 48px;
      background: linear-gradient(180deg, #4e99fd 0%, #3384e8 100%);
      border-radius: 2px 2px 2px 2px;
      font-size: 20px;
      color: white;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }
}

.pd-buttons {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 40px;
  margin-bottom: 70px;
  .pd-button {
    font-size: 20px;
    color: #096dd9;
    height: 48px;
    width: 157px;
    border: 1px solid #096dd9;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border-radius: 2px;
  }
}
.pd-name {
  font-size: 24px;
  color: #096dd9;
  margin-top: 80px;
  padding-left: 100px;
}
.pd-content {
  display: flex;
  align-items: center;
  gap: 80px;
  padding: 40px 24px 80px 100px;
  height: 410px;
  .pd-left {
    width: 410px;
    height: 410px;
    background: #ffffff;
    box-shadow: 5px 8px 20px 0px #dadada;
    border-radius: 8px 8px 8px 8px;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .pd-img {
      width: 377px;
    }
  }
  .pd-right {
    height: 100%;
    flex-grow: 1;
    overflow-y: scroll;
    line-height: 2;
    font-size: 16px;
    padding-right: 70px;
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      background: linear-gradient(180deg, #4e99fd 0%, #5482fa 100%);
    }
    &::-webkit-scrollbar-track {
      background: #e7e7e7;
    }

    .pd-brief {
      color: #666666;
      margin-bottom: 8px;
    }
    .pd-feature {
      color: #096dd9;
      margin-bottom: 8px;
    }
  }
}
</style>
